import type ThemeDataType from 'owa-service/lib/contract/ThemeDataType';
import type { BookingThemeData } from 'owa-graph-schema';

const mapBookingThemeData = (themeData: BookingThemeData): ThemeDataType => {
    const { paletteId, patternId, pictureId } = themeData;
    const modifiedThemeData = {
        PaletteId: paletteId ?? 0,
        PatternId: patternId ?? 0,
        PictureId: pictureId ?? 0,
    };
    return modifiedThemeData;
};

export default mapBookingThemeData;
